import { __assign } from "tslib";
import React from 'react';
import { isPanelHeightSufficient } from '@coherence-design-system/utilities';
import { classNamesFunction, getId, Panel, PanelType } from '@fluentui/react';
import { CoherencePanelNavigation, CoherencePanelHeader, CoherencePanelBody, CoherencePanelFooter } from './components';
var getClassNames = classNamesFunction();
var coherencePanelBase = function (props) {
    var styles = props.styles, titleText = props.titleText, onRenderFooter = props.onRenderFooter, theme = props.theme, _a = props.hasCloseButton, hasCloseButton = _a === void 0 ? true : _a, panelSize = props.panelSize, onDismiss = props.onDismiss, isLightDismiss = props.isLightDismiss, backButton = props.backButton, children = props.children, onRenderHeader = props.onRenderHeader, closeButtonAriaLabel = props.closeButtonAriaLabel, onRenderNavigation = props.onRenderNavigation, onRenderAdditionalNavigationContent = props.onRenderAdditionalNavigationContent;
    var uniqueId = React.useState(getId('CoherPanel'))[0];
    React.useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var handleResize = function () {
        var panelHeightSufficient = isPanelHeightSufficient();
        setIsShort(panelHeightSufficient);
    };
    var _b = React.useState(isPanelHeightSufficient()), isShort = _b[0], setIsShort = _b[1];
    var noNavHeader = !hasCloseButton &&
        !backButton &&
        onRenderNavigation === undefined &&
        onRenderAdditionalNavigationContent === undefined;
    var classNames = getClassNames(styles, {
        theme: theme,
        isFooterInBody: isShort,
        panelSize: panelSize,
        hasNavigationHeader: !noNavHeader
    });
    var _getCloseButton = function () {
        return isShort ? true : hasCloseButton !== null && hasCloseButton !== void 0 ? hasCloseButton : true;
    };
    var getNavigationComponent = function (panelProps, defaultRender) {
        var _props = {
            onRenderNavigation: onRenderAdditionalNavigationContent,
            backButton: backButton,
            styles: styles,
            theme: theme,
            panelProps: panelProps,
            defaultRender: defaultRender
        };
        return React.createElement(CoherencePanelNavigation, __assign({}, _props));
    };
    var getHeader = function (panelProps, __, headerId) {
        var _props = {
            headerId: headerId,
            titleText: titleText,
            panelProps: panelProps,
            onRenderHeader: onRenderHeader,
            theme: theme,
            styles: styles,
            isFooterInBody: isShort,
            hasNavigationHeader: !noNavHeader
        };
        return React.createElement(CoherencePanelHeader, __assign({}, _props));
    };
    var getBody = function () {
        var _props = {
            showAccessibleCloseButton: Boolean(!hasCloseButton && !(!isShort && onRenderFooter)),
            theme: theme,
            styles: styles,
            onDismiss: onDismiss,
            onRenderFooter: onRenderFooter
        };
        return React.createElement(CoherencePanelBody, __assign({}, _props), children);
    };
    var getFooterComponent = function () {
        var shouldShowFooter = onRenderFooter ? true : false;
        var _props = {
            showRenderFooter: shouldShowFooter,
            hasCloseButton: hasCloseButton,
            theme: theme,
            styles: styles,
            onDismiss: onDismiss,
            onRenderFooter: onRenderFooter
        };
        return React.createElement(CoherencePanelFooter, __assign({}, _props));
    };
    return (React.createElement(Panel, __assign({}, props, { id: uniqueId, headerText: titleText, hasCloseButton: _getCloseButton(), isLightDismiss: isLightDismiss !== undefined ? isLightDismiss : true, type: PanelType.custom, styles: classNames.subComponentStyles.panelStyles, isFooterAtBottom: true, onRenderHeader: getHeader, onRenderBody: getBody, onRenderFooter: getFooterComponent, onRenderNavigationContent: getNavigationComponent, closeButtonAriaLabel: closeButtonAriaLabel !== null && closeButtonAriaLabel !== void 0 ? closeButtonAriaLabel : 'Close' })));
};
export { coherencePanelBase as CoherencePanelBase };
//# sourceMappingURL=CoherencePanel.base.js.map